<template>
  <div class="flex-grow-1" v-bind:style="{ 'background-color': order.skin.page_background_color }">

    <group-video-editor
      v-if="showEditGroupVideoBlob"
      :key="showEditGroupVideoBlob.group_video.project_id + showEditGroupVideoBlob.group_video.template_id"
      purchase-dialog
      :project-id="showEditGroupVideoBlob.group_video.project_id"
      :order="order"
      :value="true"
      @input="showEditGroupVideoBlob = null"
    />

    <template v-if="showGiftcardBlob">
      <giftcard-edit-dialog
        v-if="order.state == 'PENDING'"
        :order="order"
        :blob="showGiftcardBlob"
        :max-giftcard-value="maxGiftcardValue"
        :max-giftcard-value-remaining="maxGiftcardValueRemaining"
        @input="showGiftcardBlob = null"
      />
      <giftcard-add-dialog
        v-else
        no-mutation
        :order-id="orderId"
        :order="order"
        :blob="showGiftcardBlob"
        :locked="order.state == 'CANCELLED'"
        :max-value="maxGiftcardValueRemaining"
        @input="showGiftcardBlob = null"
        @complete="$emit('load-order')"
      />
    </template>

    <form-rsvp-recipient-dialog
      v-if="showRSVP"
      :token="orderId"
      :order="order"
      :preview="true"
      :is-sample="true"
      v-model="showRSVP"
      @edit-event="showRSVP = false; $router.push({ hash: '#event' });"
    />

    <card-background :src="order.skin.page_background_img" />

    <group-video-editor
      v-if="order.design_id == nullCoverDesignId"
      :key="groupVideoBlob.group_video.project_id + groupVideoBlob.group_video.template_id"
      class="fill-height"
      block purchase-dialog
      :project-id="groupVideoBlob.group_video.project_id"
      :order="order"
    />

    <!-- TODO: the @click-add-group-video is broken for new customers - by navigating away, you'd lose your current progress. That needs to open a dialog... -->
    <card-editor
      v-else
      class="overflow-hidden"
      :order-id="orderId"
      :mode="(order.state == 'PENDING') ? 'purchase' : (order.state == 'CANCELLED') ? 'view' : 'edit'"
      :card="order"
      :padding-top="paddingTop"
      :is-owner="true"
      :has-group-video="!!groupVideoBlob"
      :max-giftcard-value="maxGiftcardValueRemaining"
      :show-help="global.showHelp"
      :show-giftcard-block="orderDirty"
      :show-automation-opts="automation"
      @click-group-video="x => showEditGroupVideoBlob = x"
      @click-giftcard="
        x => {
          if (orderDirty)
            $confirm({
              title: 'Unsaved changes',
              msg: 'Please save or discard your other changes before adding a gift card',
              buttons: [ 'Ok' ],
              primary: 'Ok'
            });
          else
            showGiftcardBlob = x;
        }
      "
      @click-rsvp="showRSVP = true"
      @click-add-group-video="$router.push({ name: 'catalog-video' })"
      @step-to="v => $router.push({ hash: '#' + v })"
      @reload="$emit('load-order')"
    />
  </div>
</template>

<script>
import CardBackground from '@/components/CardBackground.vue';
import CardEditor from '@/components/CardEditor.vue';
import FormRsvpRecipientDialog from '@/components/FormRsvpRecipientDialog.vue';
import GiftcardAddDialog from '@/components/GiftcardAddDialog.vue';
import GiftcardEditDialog from '@/components/GiftcardEditDialog.vue';
import { publicDesign } from '@/mixins/public-design.js';
import { findGroupVideoBlob } from '@/utils/group-video.js';


export default {
  name: 'order-stepper-card-editor',

  components: {
    CardBackground,
    CardEditor,
    FormRsvpRecipientDialog,
    GiftcardAddDialog,
    GiftcardEditDialog,
    GroupVideoEditor: () => import('@/components/GroupVideoEditor.vue')
  },

  mixins: [ publicDesign ],

  props: [ 'orderId', 'order', 'paddingTop', 'orderDirty', 'automation' ],

  data() {
    return {
      showEditGroupVideoBlob: null,
      showGiftcardBlob: null,
      showRSVP: false
    };
  },

  computed: {
    groupVideoBlob() {
      return findGroupVideoBlob(this.order);
    },

    maxGiftcardValue() {
      return (this.order.skin.max_giftcard_value == 0) ? 0 : (this.order.skin.max_giftcard_value || 500000);
    },

    maxGiftcardValueRemaining() {
      if (this.maxGiftcardValue == 0)
        return 0;
      let total = 0;
      for (const page of this.order.pages)
        for (const blob of page.blobs)
          if (blob.type == 'GIFTCARD')
            total += blob.giftcard.amt;
      return this.maxGiftcardValue - total;
    }
  }
}
</script>
